import React from "react";

import { NavLink } from "react-router-dom";
import { Box } from "@mui/material";

import {
  SidebarMenu as SidebarMenuTelluriaUi,
  SidebarMenuProps as SidebarMenuPropsTelluriaUi
} from "@npm-telluria-tecnologia/telluria-ui";

interface SidebarMenuProps extends SidebarMenuPropsTelluriaUi {
  link: string;
  /** Shows a dot over the icon (a new version not seen yet, on Documentação) */
  badge?: boolean;
}

const dotSx = {
  position: "absolute",
  top: 12,
  left: "calc(50% + 8px)",
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: "#f50057",
  pointerEvents: "none"
};

const SidebarMenu: React.FC<SidebarMenuProps> = ({
  id,
  title,
  icon,
  identifierColor,
  link,
  badge
}) => (
  <NavLink to={link}>
    <Box sx={{ position: "relative" }}>
      <SidebarMenuTelluriaUi
        key={`${id}_${title}`}
        id={id}
        title={title}
        icon={icon}
        identifierColor={identifierColor}
      />
      {badge && <Box component="span" sx={dotSx} />}
    </Box>
  </NavLink>
);

SidebarMenu.defaultProps = {
  badge: false
};

export default SidebarMenu;
